<div class="funcao-table-container mat-elevation-z2 mb-1">
  <table mat-table [dataSource]="funcoes$ | async">

    <ng-container matColumnDef="funcao">
      <th mat-header-cell *matHeaderCellDef> Função </th>
      <td mat-cell *matCellDef="let element"> {{element.nome}} </td>
    </ng-container>

    <ng-container matColumnDef="categoria">
      <th mat-header-cell *matHeaderCellDef> Categoria </th>
      <td mat-cell *matCellDef="let element"> {{element.categoria}} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let element" class="d-flex justify-content-center pt-1 pb-1">
        <button
          mat-icon-button
          color="warn"
          type="button"
          title="Remover"
          (click)="removerFuncao(element)">
          <i class="fas fa-minus-circle" aria-hidden="true"></i>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">
        <span style="color: darkgray">Nenhuma função adicionada.</span>
      </td>
    </tr>
  </table>
</div>
